import { render, staticRenderFns } from "./EmptyCardsIcon.vue?vue&type=template&id=2548c198"
import script from "./EmptyCardsIcon.vue?vue&type=script&lang=js"
export * from "./EmptyCardsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports